import { observable, action } from 'mobx';
import { clone } from 'utils';
import documentationAdapter from 'adapters/DocumentationAdapter';

class DocumentationStore {
  @observable links = [];
  @observable isLoadingLinks = false;

  @action
  loadLinks() {
    this.isLoadingLinks = true;
    return documentationAdapter
      .loadLinks()
      .then(
        action((links) => {
          this.isLoadingLinks = false;
          this.links = clone(links);
          return links;
        })
      )
      .catch(
        action(() => {
          this.isLoadingLinks = false;
        })
      );
  }

}

const instance = new DocumentationStore();

export default instance;


// WEBPACK FOOTER //
// ./src/stores/DocumentationStore.js